import OneSignal from 'react-onesignal';

export default async function runOneSignal() {
  // await OneSignal.init({ appId: '6771810e-4b5e-41bf-ad59-c181b6bbba24', allowLocalhostAsSecureOrigin: true, allowLocalhostAsSecureOrigin: true,})
  // OneSignal.Slidedown.promptPush();
}